import app from 'flarum/common/app';
import Icon from 'flarum/common/components/Icon';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
export default class MobileTabSessionDropdown extends SessionDropdown {
  getButtonContent() {
    return [m(Icon, {
      name: "fas fa-user-cog",
      className: "Button-icon"
    }), ' ',
    // The username can be long, so it is better to display "Profile"
    m("span", {
      className: "Button-label"
    }, app.translator.trans('acpl-mobile-tab.lib.item.profile'))];
  }
}
flarum.reg.add('gitzaai-v2mobileui', 'forum/components/MobileTabSessionDropdown', MobileTabSessionDropdown);